import Vue from 'vue'

export default {
  setConfig(state, config) {
    Vue.set(state, 'config', config)
  },
  login(state, userData) {
    state.token = userData.token
    const user = {
      avatar: userData.avatar,
      email: userData.email,
      displayname: userData.displayname,
      id: userData.id,
      is_admin: userData.is_admin,
      name: userData.name,
      privacy_policy_accepted: userData.privacy_policy_accepted,
      privacy_policy_acceptance_status: userData.privacy_policy_acceptance_status,
      privacy_policy_required: userData.privacy_policy_required,
      tmpAccount: userData.isTmpAccount,
      tos_accepted: userData.tos_accepted,
      tos_acceptance_status: userData.tos_acceptance_status,
    }
    if (typeof userData.active !== 'undefined' && !userData.active) {
      user.active = false
    } else {
      user.active = true
    }
    Vue.set(state, 'user', user)
  },
  setToken(state, token) {
    state.token = token
  },
  setProfileData(state, data) {
    if (typeof state.user === 'undefined' || !state.user) {
      Vue.set(state, 'user', {})
    }
    Vue.set(state.user, 'id', data.id)
    Vue.set(state.user, 'name', data.name)
    Vue.set(state.user, 'privacy_policy_accepted', data.privacy_policy_accepted)
    Vue.set(state.user, 'privacy_policy_acceptance_status', data.privacy_policy_acceptance_status)
    Vue.set(state.user, 'privacy_policy_required', data.privacy_policy_required)
    Vue.set(state.user, 'tos_accepted', data.tos_accepted)
    Vue.set(state.user, 'tos_acceptance_status', data.tos_acceptance_status)
    Vue.set(state.user, 'email', data.email)
    Vue.set(state.user, 'avatar', data.avatar)
    Vue.set(state.user, 'is_admin', data.is_admin)
  },
  setTmpAccount(state, isTmpAccount) {
    Vue.set(state.user, 'tmpAccount', isTmpAccount)
  },
  setAvatar(state, avatar) {
    Vue.set(state.user, 'avatar', avatar)
  },
  setEmail(state, email) {
    Vue.set(state.user, 'email', email)
  },
  setUsername(state, username) {
    Vue.set(state.user, 'username', username)
  },
  setLocale(state, locale) {
    state.locale = locale
  },
  setBrowserLocaleDetected(state, browserLocaleDetected) {
    state.browserLocaleDetected = browserLocaleDetected
  },
  setLocaleManuallySelected(state, localeManuallySelected) {
    state.localeManuallySelected = localeManuallySelected
  },
  setAuthPages(state, pages) {
    state.authPages = pages
  },
  setLegalAcceptance(state, data) {
    Vue.set(state.user, 'privacy_policy_accepted', data.privacy_policy_accepted)
    Vue.set(state.user, 'privacy_policy_acceptance_status', data.privacy_policy_acceptance_status)
    Vue.set(state.user, 'privacy_policy_required', data.privacy_policy_required)
    Vue.set(state.user, 'tos_accepted', data.tos_accepted)
    Vue.set(state.user, 'tos_acceptance_status', data.tos_acceptance_status)
  },
  activate(state) {
    Vue.set(state.user, 'active', true)
  },
  logout(state) {
    Vue.set(state, 'user', null)
    Vue.set(state, 'token', null)
    Vue.set(state, 'config', null)
    Vue.set(state, 'localeManuallySelected', false)
    // Also reset the old api_token, because otherwise the user would be automatically logged in the next time they reload the page
    window.localStorage.removeItem('api_token')
  },
  hideInstallPrompt(state) {
    state.installPromptHidden = true
  },
  setFCMToken(state, token) {
    state.fcmToken = token
  },
}
